import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { EntityTag } from '@coin/shared/core/util-models';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { TagTooltipPipe } from '../../pipes/tag-tooltip.pipe';
import { V2CardComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'customer-position-list-item-tags',
  templateUrl: './position-list-item-tags.component.html',
  styleUrls: ['./position-list-item-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2CardComponent, MatIcon, MatTooltip, TranslatePipe, TagTooltipPipe]
})
export class PositionListItemTagsComponent {
  @Input() tags?: EntityTag[];
}
